import { z } from 'zod';

export const SortDirectionType = z.enum(['asc', 'desc']);

/** Dataset sort-direction value: ascending or descending order. */
export type SortDirection = z.infer<typeof SortDirectionType>;

export const FillDirectionType = z.enum(['ffill', 'bfill']);

/** Gap-fill carry direction: forward-fill or back-fill. */
export type FillDirection = z.infer<typeof FillDirectionType>;

/**
 * Zod schema for Cognite Data Fusion instance identifiers.
 *
 * @property space - The space where the instance resides
 * @property externalId - Unique identifier within the space
 */
export const InstanceIdType = z.object({ space: z.string(), externalId: z.string() });

/** TypeScript type for CDF instance identifiers. */
export type InstanceIdType = z.infer<typeof InstanceIdType>;

export const TimeSeriesRefType = z.object({ space: z.string().optional(), externalId: z.string() });

export type TimeSeriesRefType = z.infer<typeof TimeSeriesRefType>;
